module.exports = __webpack_public_path__ + "static/media/freelancer-onboarding-avatar-1.629efabe.webp";